var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 413,
    height: 88,
    viewBox: "0 0 413 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 72.9999V15H8.75214V72.9999H0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2239 72.9999V15H24.9113L54.4415 57.3722V15H63.3272V72.9999H53.6397L24.0428 30.5472V72.9999H15.2239Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0491 72.9999V25.7139H68.4069V15H116.51V25.7139H96.9349V72.9999H88.0491Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.641 49.3972V38.6028L158.987 38.6027V49.3972L121.641 49.3972Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.641 62.2861V72.9999H165.936V62.286L121.641 62.2861Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.641 25.7139V15H165.936V25.7139L143.788 25.7139L121.641 25.7139Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M172.658 72.9999V15H182.346L211.876 57.3722V15H220.762V72.9999H211.074L181.477 30.5472V72.9999H172.658Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M237.533 72.9999C235.841 72.9999 234.282 72.4897 232.857 71.4694C231.476 70.449 230.362 69.1064 229.516 67.4416C228.67 65.7231 228.247 63.8434 228.247 61.8027V26.1972C228.247 24.1565 228.67 22.3037 229.516 20.6389C230.362 18.9204 231.476 17.5509 232.857 16.5306C234.282 15.5102 235.841 15 237.533 15H276.216V25.7139H239.404C238.691 25.7139 238.112 25.9555 237.667 26.4389C237.266 26.9222 237.066 27.6203 237.066 28.5333V59.4666C237.066 60.3259 237.266 61.024 237.667 61.561C238.112 62.0444 238.691 62.286 239.404 62.286H276.216V72.9999H237.533Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M283.316 49.3972V38.6028L320.663 38.6027V49.3972L283.316 49.3972Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M283.316 62.2861V72.9999H327.611V62.286L283.316 62.2861Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M283.316 25.7139V15H327.611V25.7139L283.316 25.7139Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.468 72.9999V26.1972C334.468 24.1565 334.891 22.3037 335.737 20.6389C336.583 18.9204 337.697 17.5509 339.078 16.5306C340.503 15.5102 342.062 15 343.754 15H373.218C374.91 15 376.469 15.5102 377.894 16.5306C379.32 17.5509 380.455 18.9204 381.302 20.6389C382.148 22.3037 382.571 24.1565 382.571 26.1972V72.9999H373.685V53.5055H343.287V72.9999H334.468ZM343.287 42.8722H373.685V26.6805C373.685 26.412 373.596 26.1972 373.418 26.0361C373.24 25.8213 373.039 25.7139 372.817 25.7139H344.088C343.866 25.7139 343.665 25.8213 343.487 26.0361C343.353 26.1972 343.287 26.412 343.287 26.6805V42.8722Z",
    fill: "#1F69FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M389.248 72.9999V15H398V72.9999H389.248Z",
    fill: "#1F69FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M334.46 73V26.1973C334.46 24.1566 334.883 22.3038 335.729 20.639C336.575 18.9205 337.689 17.551 339.07 16.5306C340.495 15.5103 342.054 15.0001 343.746 15.0001H373.21C374.902 15.0001 376.461 15.5103 377.886 16.5306C379.312 17.551 380.448 18.9205 381.294 20.639C382.14 22.3038 382.563 24.1566 382.563 26.1973V73H373.677V53.5056H343.279V73H334.46ZM343.279 42.8723H373.677V26.6806C373.677 26.4121 373.588 26.1973 373.41 26.0362C373.232 25.8214 373.032 25.714 372.809 25.714H344.08C343.858 25.714 343.657 25.8214 343.479 26.0362C343.346 26.1973 343.279 26.4121 343.279 26.6806V42.8723Z",
    fill: "#1F69FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M389.24 73V15.0001H397.992V73H389.24Z",
    fill: "#1F69FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1629_384)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.468 72.9999V26.1972C334.468 24.1565 334.891 22.3037 335.737 20.6389C336.583 18.9204 337.697 17.5509 339.078 16.5306C340.503 15.5102 342.062 15 343.754 15H373.218C374.91 15 376.469 15.5102 377.894 16.5306C379.32 17.5509 380.455 18.9204 381.302 20.6389C382.148 22.3037 382.571 24.1565 382.571 26.1972V72.9999H373.685V53.5055H343.287V72.9999H334.468ZM343.287 42.8722H373.685V26.6805C373.685 26.412 373.596 26.1972 373.418 26.0361C373.24 25.8213 373.039 25.7139 372.817 25.7139H344.088C343.866 25.7139 343.665 25.8213 343.487 26.0361C343.353 26.1972 343.287 26.412 343.287 26.6805V42.8722Z",
    fill: "#1F69FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.248 72.9999V15H398V72.9999H389.248Z",
    fill: "#1F69FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.46 73V26.1973C334.46 24.1566 334.883 22.3038 335.729 20.639C336.575 18.9205 337.689 17.551 339.07 16.5306C340.495 15.5103 342.054 15.0001 343.746 15.0001H373.21C374.902 15.0001 376.461 15.5103 377.886 16.5306C379.312 17.551 380.448 18.9205 381.294 20.639C382.14 22.3038 382.563 24.1566 382.563 26.1973V73H373.677V53.5056H343.279V73H334.46ZM343.279 42.8723H373.677V26.6806C373.677 26.4121 373.588 26.1973 373.41 26.0362C373.232 25.8214 373.032 25.714 372.809 25.714H344.081C343.858 25.714 343.657 25.8214 343.479 26.0362C343.346 26.1973 343.279 26.4121 343.279 26.6806V42.8723Z",
    fill: "#1F69FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.24 73V15.0001H397.992V73H389.24Z",
    fill: "#1F69FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1629_384",
    x: 319.46,
    y: 0,
    width: 93.5402,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.184314 0 0 0 0 0.454902 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1629_384"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1629_384",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6ea4a455bfcdbb1e5f84a130b57d475a.svg";
export { ForwardRef as ReactComponent };